/* eslint-disable no-unreachable */
/* eslint-disable no-fallthrough */
import PaginationComponent from "./PaginationComponent";
import {
  employeeStatusHandler,
  getInitials,
  handleAttendanceStatus,
  handleBudgetRequestStatus,
  HandlePurchaseRequestStatus,
  handleStatus,
  handleWorkOrderStatus,
} from "../../utility/CommonFunctions";
import NoRecordIcon from "../Icons/NoRecordIcon";
import { useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { RoutesLink } from "../../ApiHelper/RoutesLink";
import { Fragment } from "react";

export default function CommonTable({
  TableHeading,
  TableData,
  isLoading,
  currentPage,
  count,
  totalPages,
  PageChangeHandler,
  ActionData,
  handleStatusToggle,
  handleChangePageSize,
  pageSize,
  handleChangeAttendance,
  selectedRows,
  setSelectedRows,
  onSelectionChange,
  rowKey,
}) {
  const userDetails = useSelector((state) => state.root.userDetails);
  const navigate = useNavigate();
  const renderTableData = (heading, data, index) => {
    const handleNavigateToEmployeeDetail = () => {
      navigate(`${RoutesLink?.employee_detail}/${data?.user?.id || data?.id}`);
    };
    // console.log("data>>>>",heading, data);
    // console.log("count>>>>>",count,"totalPages>>>>>>>",totalPages);
    // console.log("TableData>>>>>in>>>CommonTable>>>>>>", TableData);
    // console.log("pageSize>>>>.", pageSize);

    switch (heading.value) {
      case "index":
        return (
          <td className="text-start">
            {((currentPage - 1) * pageSize + index + 1)
              .toString()
              .padStart(2, "0")}
          </td>
        );
      case "indexNo":
        return <td>{data[heading?.value]}</td>;
      case "leaveStatus":
        return <td className="text-start">{handleStatus(data[heading.value])}</td>;
      case "wfhStatus":
        return <td className="text-start">{handleStatus(data[heading.value])}</td>;
      case "Arstatus":
        return <td className="text-start">{handleStatus(data[heading.value])}</td>;
      case "odStatus":
        return <td className="text-start">{handleStatus(data[heading.value])}</td>;
      case "budgetStatus":
        return <td className="text-start">{handleStatus(data[heading.value])}</td>;
      case "budgetRequestStatus":
        return <td className="text-start">{handleBudgetRequestStatus(data[heading.value])}</td>;
      case "attendanceStatus":
        return <td className="text-start">{handleAttendanceStatus(data[heading.value])}</td>;
      case "attendanceStatusToggle":
        // printData("status", data[heading.value]);
        const getClassName = () => {
          switch (data[heading.value]) {
            case 1:
              return "text-success";
            case 0:
              return "text-danger";
            case 2:
              return "text-warning";
            case 3:
              return "text-info";
            case 4:
              return "text-warning";
            case 5:
              return "text-warning";
            case 6:
              return "text-warning";
            case 7:
              return "text-warning";
            case 8:
              return "text-success";
            case 9:
              return "text-warning";
            default:
              return "";
          }
        };

        return (
          <td>
            {
              <>
                <select
                  className={`form-select fw-normal status-dropdown rounded-4 px-3 ${getClassName()}`}
                  value={data[heading.value]}
                  onChange={(e) =>
                    handleChangeAttendance(
                      Number(e.target.value),
                      data?.id,
                      data?.name
                    )
                  }
                  disabled={
                    data?.attendances?.[0]?.isLockedAttendance ||
                    (userDetails?.department?.name !== "HRM" &&
                      !(
                        userDetails?.department?.name === "Solar / Wind" &&
                        userDetails?.designation?.name === "Plant Head"
                      ))
                  }
                >
                  {
                    <option style={{ color: "green" }} value={1}>
                      Present
                    </option>
                  }
                  <option style={{ color: "red" }} value={0}>
                    Absent
                  </option>
                  <option
                    style={{ color: "orange", display: "none" }}
                    disabled
                    value={2}
                  >
                    Pending
                  </option>
                  {
                    <option style={{ color: "cyan" }} value={3}>
                      On Leave
                    </option>
                  }
                  {
                    <option
                      className="d-none"
                      style={{ color: "orange" }}
                      value={4}
                    >
                      Pending Leave
                    </option>
                  }
                  {
                    <option
                      className="d-none"
                      style={{ color: "orange" }}
                      value={5}
                    >
                      Pending AR
                    </option>
                  }
                  {
                    <option
                      className="d-none"
                      style={{ color: "orange" }}
                      value={6}
                    >
                      Pending OD
                    </option>
                  }
                  {
                    <option
                      className="d-none"
                      style={{ color: "orange" }}
                      value={7}
                    >
                      Weekly Off
                    </option>
                  }
                  {
                    <option
                      className="d-none"
                      style={{ color: "orange" }}
                      value={8}
                    >
                      WFH
                    </option>
                  }
                  {
                    <option
                      className="d-none"
                      style={{ color: "green" }}
                      value={9}
                    >
                      Pending WFH
                    </option>
                  }
                </select>
              </>
            }
          </td>
        );
      case "toggleStatus":
        return (
          <td>
            <div className="form-check form-switch d-flex justify-content-start">
              <input
                type="checkbox"
                className="form-check-input rounded-4"
                checked={!!data[heading.value]}
                onChange={() => handleStatusToggle(data, data[heading.value])}
              />
            </div>
          </td>
        );
      // ---- Item Master cells (additive, used only by ItemMaster.jsx) ----
      case "itemPhoto":
        return (
          <td className="text-center">
            <div className="d-flex justify-content-center align-items-center">
              {data?.photoUrl ? (
                <img
                  src={data?.photoUrl}
                  alt={data?.name || "item"}
                  className="erp-item-photo"
                />
              ) : (
                <div
                  className={`erp-item-photo-fallback ${data?.category || "general"}`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
                    <path d="m3.3 7 8.7 5 8.7-5" />
                    <path d="M12 22V12" />
                  </svg>
                </div>
              )}
            </div>
          </td>
        );
      case "itemNameSub":
        return (
          <td className="text-start">
            <div className="d-flex flex-column">
              <span>{data?.name || "--"}</span>
              {data?.nameSubtitle && (
                <small className="erp-item-subtitle">
                  {data?.nameSubtitle}
                </small>
              )}
            </div>
          </td>
        );
      case "categoryBadge":
        return (
          <td className="text-start">
            <span
              className={`badge ${data[heading.value] === "supply"
                ? "bg-blue-25"
                : data[heading.value] === "service"
                  ? "bg-green-25"
                  : "bg-grey-25"
                } fw-normal rounded-pill text-capitalize`}
            >
              {data[heading.value] || "--"}
            </span>
          </td>
        );
      case "itemStatusBadge":
        return (
          <td className="text-start">
            <span
              className={`badge ${data[heading.value] ? "bg-green-25" : "bg-red-25"
                } fw-normal rounded-pill`}
            >
              {data[heading.value] ? "Active" : "Inactive"}
            </span>
          </td>
        );
      case "employeeStatus":
        return <td className="text-start">{employeeStatusHandler(data[heading.value])}</td>;
      case "workOrderStatus":
        return <td className="text-start">{handleWorkOrderStatus(data[heading.value])}</td>
      case "companylogo":
        return (
          <td>
            <div className="">
              <span>
                <img
                  src={data[heading.value]}
                  alt=""
                  className="rounded"
                  width="40"
                  height="40"
                />
              </span>
            </div>
          </td>
        );
      case "siteStatus":
        if (data[heading.value] === 1 || data[heading.value] === true) {
          return (
            <td>
              <span className="badge bg-green-25 fw-normal rounded-pill">
                Active
              </span>
            </td>
          );
        } else if (data[heading.value] === 0 || data[heading.value] === false) {
          return (
            <td>
              <span className="badge bg-yellow-25 fw-normal rounded-pill">
                inactive
              </span>
            </td>
          );
        }
      case "emp":
        return (
          <td>
            <div className="user">
              <span className="user-icon">
                {" "}
                {getInitials(data[heading.value])}{" "}
              </span>
              <div>
                <span className="fw-medium text-dark">{data[heading.value]}</span>
                {/* <p className="mb-0">N/A</p> */}
              </div>
            </div>
          </td>
        );
      case "empNameWithImage":
        return (
          <td>
            <div
              className="user d-flex align-items-center"
              onClick={handleNavigateToEmployeeDetail}
              style={{ cursor: "pointer" }}
            >
              {(data[heading.value]?.split("##")?.[1] && data[heading.value]?.split("##")?.[1] !== "null" && data[heading.value]?.split("##")?.[1] !== "undefined") ? (
                <img
                  src={data[heading.value]?.split("##")?.[1]}
                  alt="User"
                  className="user-avatar me-2"
                  style={{ width: "30px", height: "30px", borderRadius: "50%" }}
                />
              ) : (
                <span className="user-icon me-2">
                  {getInitials(data[heading.value]?.split("##")?.[0])}
                </span>
              )}

              <div>
                <span className="fw-medium text-dark">
                  {data[heading.value]?.split("##")?.[0]}
                </span>
              </div>
            </div>
          </td>
        );
      case "reqType":
        return (
          <td>
            <span
              className={`${data[heading?.value] === "Supply Request"
                ? "badge bg-blue-25 fw-normal rounded-pill"
                : "badge bg-grey-25 fw-normal rounded-pill"
                } `}
            >
              {data[heading.value]}
            </span>
          </td>
        );
      case "purchaseRequestStatus":
        return data[heading.value] === "PO Short Closed" ? (
          <td>
            <span className="badge bg-red-25 fw-normal rounded-pill">
              {data[heading.value]}
            </span>
          </td>
        ) : (
          <td className="text-start">{HandlePurchaseRequestStatus(data[heading.value])}</td>
        );
      case "stockStatus":
        if (data[heading.value] === 0) {
          return (
            <td>
              <span className="badge  bg-red-25 fw-normal rounded-pill">
                Pending
              </span>
            </td>
          );
        } else if (data[heading.value] === 1) {
          return (
            <td>
              <span className="badge bg-yellow-25 fw-normal rounded-pill">
                Partial
              </span>
            </td>
          );
        } else if (data[heading.value] === 2) {
          return (
            <td>
              <span className="badge bg-green-25 fw-normal rounded-pill">
                Received
              </span>
            </td>
          );
        } else {
          return (
            <td>
              <span className="">--</span>
            </td>
          );
        }
      case "DueDays":
        if (data.paymentDue == 0) {
          return (
            <td>
              <span className="">--</span>
            </td>
          );
        }
        if (data[heading.value] !== null && data[heading.value] <= 0) {
          return (
            <td>
              <span className="badge  bg-red-25 fw-normal rounded-pill">
                {data[heading.value]}
              </span>
            </td>
          );
        } else if (data[heading.value] !== null && data[heading.value] > 0) {
          return (
            <td>
              <span className="badge bg-yellow-25 fw-normal rounded-pill">
                {data[heading.value]}
              </span>
            </td>
          );
        } else {
          return (
            <td>
              <span className="">--</span>
            </td>
          );
        }
      case "isSalaryCreated":
        if (!data[heading.value]) {
          return (
            <td>
              <span className="badge  bg-red-25 fw-normal rounded-pill">
                Pending
              </span>
            </td>
          );
        } else {
          return (
            <td>
              <span className="badge bg-green-25 fw-normal rounded-pill">
                Created
              </span>
            </td>
          );
        }
      case "paymentTicketStatus":
        return data[heading.value] === "PO Short Closed" ? (
          <td className="text-start">
            <span className="badge bg-danger fw-normal rounded-pill">
              {data[heading.value]}
            </span>
          </td>
        ) : (
          <td className="text-start">{HandlePurchaseRequestStatus(data[heading.value])}</td>
        );
      case "paymentStatus":
        const statusVal = String(data[heading.value] || "").toLowerCase();
        if (statusVal === "pending") {
          return (
            <td className="text-start">
              <span className="badge  bg-yellow-25 fw-normal rounded-pill">
                Pending
              </span>
            </td>
          );
        } else if (statusVal === "full payment") {
          return (
            <td className="text-start">
              <span className="badge bg-green-25 fw-normal rounded-pill">
                Full Payment
              </span>
            </td>
          );
        } else if (statusVal === "part payment") {
          return (
            <td className="text-start">
              <span className="badge bg-aqua-25 fw-normal rounded-pill">
                Part Payment
              </span>
            </td>
          );
        } else if (statusVal === "in progress") {
          return (
            <td className="text-start">
              <span className="badge bg-blue-25 fw-normal rounded-pill">
                In Progress
              </span>
            </td>
          );
        } else {
          return (
            <td className="text-start">
              {data[heading.value] || "--"}
            </td>
          );
        }
      case "transferRequestStatus":
        const transferStatusVal = String(data[heading.value] || "").toLowerCase();
        if (transferStatusVal === "pending") {
          return (
            <td className="text-start">
              <span className="badge  bg-yellow-25 fw-normal rounded-pill">
                Pending
              </span>
            </td>
          );
        } else if (transferStatusVal === "completed") {
          return (
            <td className="text-start">
              <span className="badge bg-green-25 fw-normal rounded-pill">
                Completed
              </span>
            </td>
          );
        } else if (transferStatusVal === "failed") {
          return (
            <td className="text-start">
              <span className="badge bg-red-25 fw-normal rounded-pill">
                Failed
              </span>
            </td>
          );
        } else {
          return (
            <td className="text-start">
              {data[heading.value] || "--"}
            </td>
          );
        }
      case "paymentTicketType":
        if (data[heading.value] === "AgainstPO") {
          return (
            <td className="text-start">
              <span className="badge bg-blue-25 fw-normal rounded-pill">
                Against PO
              </span>
            </td>
          );
        } else if (data[heading.value] === "General") {
          return (
            <td className="text-start">
              <span className="badge bg-grey-25 fw-normal rounded-pill">
                General
              </span>
            </td>
          );
        } else if (data[heading.value] === "Reimbursement") {
          return (
            <td className="text-start">
              <span className="badge bg-brown-25 fw-normal rounded-pill">
                Reimbursement
              </span>
            </td>
          );
        } else {
          return (
            <td className="text-start">
              <span>--</span>
            </td>
          );
        }
      case "purchaseNumber":
        return (
          <td className="text-start">
            <NavLink
              to={`${RoutesLink?.purchase_order_detail}/${data?.id}`}
              className=" text-black text-decoration-underline"
              role="button"
            >
              {data[heading.value]}
            </NavLink>
          </td>
        );
      case "invoiceNumber":
        return (
          <td className="text-start">
            <NavLink
              to={`${RoutesLink?.invoice_detail}/${data?.id}`}
              className=" text-black text-decoration-underline"
              role="button"
            >
              {data[heading.value]}
            </NavLink>
          </td>
        );
      case "salaryTicketNumber":
        return (
          <td className="text-start">
            <NavLink
              to={`${RoutesLink?.salary_ticket_detail}/${data?.id}`}
              className=" text-black text-decoration-underline"
              role="button"
            >
              {data[heading.value]}
            </NavLink>
          </td>
        );
      case "paymentTicketNumber":
        return (
          <td className="text-start">
            <NavLink
              to={`${RoutesLink?.payment_tickets_details}/${data?.type}/${data?.id}`}
              className=" text-black text-decoration-underline"
              role="button"
            >
              {data[heading.value]}
            </NavLink>
          </td>
        );
      case "requestNumber":
        return (
          <td className="text-start">
            <NavLink
              to={`${RoutesLink?.purchase_request_detail}/${data?.id}`}
              className=" text-black text-decoration-underline"
              role="button"
            >
              {data[heading.value]}
            </NavLink>
          </td>
        );
      case "grnNumber":
        return (
          <td className="text-start">
            <NavLink
              to={`${RoutesLink?.grn_detail}/${data?.id}`}
              className=" text-black text-decoration-underline"
              role="button"
            >
              {data[heading.value]}
            </NavLink>
          </td>
        );
      case "stockOutNumber":
        return (
          <td className="text-start">
            <NavLink
              to={`${RoutesLink?.stock_out_detail}/${data?.id}`}
              className=" text-black text-decoration-underline"
              role="button"
            >
              {data[heading.value]}
            </NavLink>
          </td>
        );
      case "taNumber":
        return (
          <td className="text-start">
            <NavLink
              to={`${RoutesLink?.transfer_asset_detail}/${data?.id}`}
              className=" text-black text-decoration-underline"
              role="button"
            >
              {data[heading.value]}
            </NavLink>
          </td>
        );
      case "salaryType":
        if (data[heading.value] === "office") {
          return (
            <td className="text-start">
              <span className="badge bg-success fw-normal rounded-pill">
                Office
              </span>
            </td>
          );
        } else if (data[heading.value] === "site") {
          return (
            <td className="text-start">
              <span className="badge bg-primary fw-normal rounded-pill">
                Site
              </span>
            </td>
          )
        } else {
          return (
            <td className="text-start">
              <span>--</span>
            </td>
          )
        }
      default:
        return (
          <td className="desc-wrapper text-start">
            {data[heading.value] || "--"}
          </td>
        );
    }
  };

  return (
    <>
      <div
        className={`manage-table main-table table-responsive  ${ActionData?.length > 0 ? "sticky-btns" : ""
          }`}
      >
        <table className="table table-hover align-middle nowrap w-100">
          <thead className="" style={{ top: 0, borderBottom: "3px solid #dee2e6" }}>
            <tr className="">
              {onSelectionChange && (
                <th>
                  <input
                    type="checkbox"
                    title={
                      selectedRows?.length > 0 ? "unselect all" : "select all"
                    }
                    className="form-check-input mb-2 rounded-2"
                    style={{ width: "18px", height: "18px" }}
                    checked={
                      TableData?.length > 0 &&
                      TableData?.every((row) =>
                        selectedRows?.includes(row[rowKey])
                      )
                    }
                    onChange={(e) => {
                      const currentPageIds = TableData.map(
                        (row) => row[rowKey]
                      );
                      onSelectionChange(e.target.checked, currentPageIds);
                    }}
                  />
                </th>
              )}
              {TableHeading?.map((data, index) => (
                <th
                  key={data?.id || index}
                  className={`${data?.value === "emp" && "text-start"
                    }  text-small text-uppercase  text-nowrap ${data?.value === "itemPhoto" ? "text-center" : "text-start"}`}
                >
                  {data?.label}
                </th>
              ))}
              {ActionData && (
                <th className=" text-small text-uppercase  text-nowrap">
                  Action
                </th>
              )}
            </tr>
          </thead>
          <tbody className={isLoading ? "loading-skeleton" : ""}>
            {isLoading ? (
              <>
                {[1, 2, 3].map((item, index) => (
                  <tr key={`skeleton-${index}`}>
                    {TableHeading?.map((action, key) => (
                      <td key={`skeleton-cell-${key}`}>
                        <div className="">....</div>
                      </td>
                    ))}
                    {ActionData && (
                      <td key={`skeleton-action-${index}`}>
                        <div className="">....</div>
                      </td>
                    )}
                  </tr>
                ))}
              </>
            ) : TableData && TableData?.length > 0 ? (
              TableData?.map((data, index) => {
                const id = data[rowKey];
                const isChecked = selectedRows?.includes(id);
                return (
                  <tr key={`row-${index}`}>
                    {onSelectionChange && (
                      <td>
                        <input
                          type="checkbox"
                          className="form-check-input mb-2 rounded-2"
                          style={{ width: "16px", height: "16px" }}
                          checked={selectedRows?.includes(data[rowKey])}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedRows([...selectedRows, data[rowKey]]);
                            } else {
                              setSelectedRows(
                                selectedRows?.filter((id) => id !== data[rowKey])
                              );
                            }
                          }}
                        />
                      </td>
                    )}
                    {TableHeading?.map((heading, hIndex) => (
                      <Fragment key={heading?.id || heading?.value || hIndex}>
                        {renderTableData(heading, data, index)}
                      </Fragment>
                    ))}
                    {ActionData && (
                      <td>
                        <div className="action-btns">
                          {ActionData?.length > 0 &&
                            ActionData?.map((action, index) => {
                              {
                                /* console.log("condition=====>",
                            
                            ) */
                              }
                              if (
                                action?.isShow === "always" ||
                                action?.isShow === data?.status ||
                                action?.isShow === data?.leaveStatus ||
                                action?.isShow === data?.Arstatus ||
                                action?.isShow === data?.odStatus ||
                                action?.isSiteEditable === data?.isUserAccess ||
                                //purchase request - create/edit button visible for only createdBy user and admin
                                (action?.isVisible === data?.status &&
                                  action?.loggedInUserId === data?.user?.id &&
                                  data?.user?.id !== undefined) ||
                                //create purchase - only for SCM department
                                (action?.status === data?.status &&
                                  action?.department === "SCM")
                              ) {
                                return (
                                  <button
                                    key={index}
                                    className={action.className}
                                    title={action.title}
                                    disabled={action?.disabled}
                                    onClick={() => action.clickHandler(data)}
                                  >
                                    {!action?.icon && action.label}
                                    {action?.icon}
                                  </button>
                                );
                              }
                            })}
                        </div>
                      </td>
                    )}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td className="text-center border-0" colSpan="12">
                  <div className="d-flex flex-column justify-colmn-center align-items-center no-data-error">
                    <NoRecordIcon />
                    {"No record found"}
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-between align-items-center pt-3 table-footer">
        <div className="d-flex align-items-center gap-2">
          {count > 0 && !isLoading && (
            <div className="dropdown short">
              <button
                className="btn dropdown-toggle border"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {pageSize}
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M6.40039 8.19922L10.0004 11.7992L13.6004 8.19922"
                      stroke="#36394A"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </span>
              </button>
              <ul className="dropdown-menu ">
                {[10, 20, 30, 40, 50, 100].map((value) => (
                  <li key={value}>
                    <button
                      className={`dropdown-item ${pageSize === value && "active"
                        }`}
                      type="button"
                      onClick={() => handleChangePageSize(value)}
                    >
                      {value}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}
          <div>
            {count > 0 && !isLoading && (
              <p
                className="mb-0 text-muted fw-medium text-uppercase"
                style={{ fontSize: "10px" }}
              >
                {`Showing ${currentPage * pageSize - (pageSize - 1)} to ${currentPage * pageSize < count
                  ? currentPage * pageSize
                  : count
                  } of ${count} entries`}
              </p>
            )}
          </div>
        </div>

        <PaginationComponent
          currentPage={currentPage}
          PageChangeHandler={PageChangeHandler}
          totalPages={totalPages}
        />
      </div>
    </>
  );
}
